
import { Component, Vue, Watch } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';
import UserIconMenuMobile from '@/app/components/user/UserIconMenuMobile.vue';
import ClientResposiveNav from '@/app/components/nav/ClientResponsiveNav.vue';
import AdminResposiveNav from '@/app/components/nav/AdminResponsiveNav.vue';
import NotificationsModal from 'ah-notifications/src/components/notifications/NotificationsModal.vue';
import NeedHelpButton from '../common/NeedHelpButton.vue';
import UpdatesModal from '@/app/components/updates/UpdatesModal.vue';
import { useAuthStore } from '@/app/store/authModule';
import { useNotificationsStore } from 'ah-notifications/src/store';

@Component({
  components: {
    UserIconMenuMobile,
    ClientResposiveNav,
    AdminResposiveNav,
    UpdatesModal,
    NotificationsModal,
    NeedHelpButton,
  },
})
export default class SideNavMobile extends Vue {
  $refs!: {
    modal: BModal;
  };

  get authStore() {
    return useAuthStore();
  }

  get notificationsStore() {
    return useNotificationsStore();
  }

  get isClientUser() {
    return this.authStore.isClientUser;
  }

  get hasUnreadNotifications() {
    return this.notificationsStore.unreadCount > 0;
  }

  get hasUnreadUpdates() {
    return this.notificationsStore.updateUnreadCount > 0;
  }

  show() {
    this.$refs.modal.show();
  }

  logout() {
    this.authStore.logout();
  }

  goToHelpLink() {
    window.open('https://www.alt21.com/faq/x-hedge/', '_blank');
  }

  get user() {
    return this.authStore.loggedInIdentity;
  }

  @Watch('$route.fullPath')
  onRouteChange() {
    this.$refs.modal.hide();
  }
}
